import { Loading } from "@/components/common/Loading";
import { Alert, Snackbar, Typography } from "@mui/material";
import { useState } from "react";
import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalFooter } from "../ModalFooter";
import { ModalHeader } from "../ModalHeader";
import { Props } from "./ModalHistoryDelete.type";
import ___PHRASE from "@/service/translate/translateService";
import { EmploymentHistoryService } from "@/service/services/EmploymentHistory.service";
import { apiResponseTranslate } from "@/toolbox/helpers/responseApi.helper";

export const ModalHistoryDelete: React.FC<Props> = (props:any): JSX.Element => {
    const { open, closeModal, history, onListHistory, clearState } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [snackBarConfig, setSnackBarConfig] = useState<any>({
      open: false,
      severity: 'error',
      message: 'Error',
      autoHideDuration: 3000,
    });

    const onDeleted= async()=>{
        setLoading(true);
        await EmploymentHistoryService.deleteEmploymentHistory(history).then((data) => {
          let apimessagge = apiResponseTranslate(data?.data?.message || '');
            setSnackBarConfig(prev => ({
                ...prev, open: true,
                severity: 'success',
                message: `${apimessagge}`
                }
             ));
            clearState && clearState();
            closeModal && closeModal();
            onListHistory && onListHistory();
        })
        setLoading(false);
    }

  return (
    <>
    {loading && <Loading/>}
    <Snackbar
        open={snackBarConfig.open} 
        autoHideDuration={snackBarConfig.autoHideDuration} 
        onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal:'right' }} >
        <Alert onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))} severity={snackBarConfig.severity}>
            {snackBarConfig.message || ""}
        </Alert>
    </Snackbar>

    <Modal
      open={open}
      handleClose={closeModal}
      disableEscapeKeyDown disableBackdropClick
      size="xs"
    >
      <ModalHeader
        text={___PHRASE("eliminar")+' '+___PHRASE("historialLaboral")}
        className='positionElements'
        onCancel={closeModal}
        clearState={clearState}
      >
      </ModalHeader>

      <ModalBody>
        <Typography variant="subtitle1" className="textColor"> 
          {___PHRASE("estaSeguroDeEliminarHistoriaLaboral")}
        </Typography>
      </ModalBody>

      <ModalFooter 
        confirmText={___PHRASE("eliminar")}
        cancelText={___PHRASE("cancelar")}
        onCancel={closeModal}
        className="footerRight"
        onConfirm={onDeleted}
        clearState={clearState}
      />
    </Modal>
    </>
  )
}